import {
  combineReducers,
  PreloadedStateShapeFromReducersMapObject,
  Store,
} from "redux";
import { configureStore } from "@reduxjs/toolkit";
import {
  themePickerReducer,
  webExperienceApi,
} from "@motain/web-shared-hub/services";
import {
  authenticationReducer,
  geolocationApi,
  screenNameReducer,
} from "@motain/web-shared-hub/features";

const rootReducer = combineReducers({
  themePicker: themePickerReducer,
  authentication: authenticationReducer,
  screenName: screenNameReducer,
  [webExperienceApi.reducerPath]: webExperienceApi.reducer,
  [geolocationApi.reducerPath]: geolocationApi.reducer,
});

export const setupStore = (
  preloadedState?: PreloadedStateShapeFromReducersMapObject<RootState>,
): Store<RootState> => {
  return configureStore({
    reducer: rootReducer,
    preloadedState,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware()
        .concat(webExperienceApi.middleware)
        .concat(geolocationApi.middleware),
  });
};

export const store = setupStore();

// Access the store's dispatch and state types
export type RootState = ReturnType<typeof rootReducer>;
export type AppStore = ReturnType<typeof setupStore>;
export type AppDispatch = AppStore["dispatch"];
